import { reducer as kyc } from "./kyc/slice";

export const reducer = {
  kyc,
};
